import React from 'react';

import { cn } from '@/utils/styles';

export const PageTitle = (props: { children: React.ReactNode; className?: string }) => {
  const { children, className } = props;
  return <h1 className={cn('text-3xl font-bold text-[#5557F6] fontInter', className)}>{children}</h1>;
};
